/*
 * @Date: 2026-01-31 10:00:00
 * @Description: 考试相关API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 获取考核信息
  getExamInfo(data) {
    return request({
      url: "/exam/getExamInfo?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 开始考核
  startExam(data) {
    return request({
      url: "/exam/startExam",
      method: "post",
      data,
    });
  },
  // 获取题目列表
  getQuestionList(data) {
    return request({
      url: "/question/getQuestionList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 提交作答
  submitAnswer(data, examId) {
    return request({
      url: "/question/submitAnswer?examId=" + examId,
      method: "post",
      data,
    });
  },
  // 保存作答
  saveAnswer(data) {
    return request({
      url: "/question/saveAnswer",
      method: "post",
      data,
    });
  },
  // 获取考核结果
  getExamRecord(data) {
    return request({
      url: "/exam/getExamRecord?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取考核列表
  getExamList(data) {
    return request({
      url: "/exam/getExamList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
};
